"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line unicorn/prefer-node-protocol
const path_1 = __importDefault(require("path"));
function getModuleParts(module) {
    const moduleId = typeof module === 'string' ? module : module.id;
    return moduleId
        .replace('.test.tsx', '')
        .replace('.tsx', '')
        .replace('.ts', '')
        .split('/')
        .filter(item => item !== '.');
}
class ModuleHelper {
    /**
     * Returns the default export of a dynamically imported module, else returns the module.
     * @param imported The dynamically imported module.
     * @param key
     */
    static unwrapDynamicImport(imported, key = 'default') {
        return __awaiter(this, void 0, void 0, function* () {
            const module = yield imported;
            return module[key] || module;
        });
    }
    /**
     * Converts a module ID or a string into a normalized path name for the text asset.
     * Attempts to remove redundant substrings from final asset path.
     *
     * Example:
     *
     * <code>
     * './components/community/LanguageChooser/LanguageChooser.tsx';
     * </code>
     *
     * Becomes:
     *
     * <code>
     * 'components/community/LanguageChooser';
     * </code>
     *
     * @param {String | module} module - The JavaScript module for the component/page.
     * @returns {String} The computed file name for a text asset based on the module name.
     *
     * @author Dolan Halbrook
     */
    static getNamespaceFromModule(module) {
        const parts = getModuleParts(module);
        // If the last part is the same as the second to last part, then
        // we remove it. This is assumed to be the case when not using index files
        // and instead using named files in similarly named directories.
        if (parts.length > 2 && parts.at(-2) === parts.at(-1)) {
            parts.pop();
        }
        // remove any relative reference to the shared directory
        return parts.join('/').replace(/^..\/shared/, 'shared');
    }
    static getDependenciesWithText(id, componentDependencies, results, processedIds = []) {
        processedIds.push(id);
        if (!results.includes(id)) {
            const dependencies = componentDependencies[id] || [];
            if (id.includes('/')) {
                results.push(id);
            }
            dependencies.forEach(dep => {
                if (!processedIds.includes(dep)) {
                    ModuleHelper.getDependenciesWithText(dep, componentDependencies, results, processedIds);
                }
            });
        }
    }
    /**
     * For a given module namespace, get all child dependencies.
     * @param module The node module
     * @param componentDependencies
     */
    static getTextDependencies(module, componentDependencies) {
        const deps = [];
        const namespace = ModuleHelper.getNamespaceFromModule(module);
        ModuleHelper.getDependenciesWithText(namespace, componentDependencies, deps);
        return deps;
    }
    /**
     * Resolve the app directory from anywhere in the filesystem.
     * @param projectDirectory The name of the project directory
     * @param baseDirectory The nodejs __basedir (varies depends on where source is compiled)
     */
    static resolveAppDirectory(projectDirectory, baseDirectory) {
        const [prefix, appPath] = baseDirectory === null || baseDirectory === void 0 ? void 0 : baseDirectory.split(`/${projectDirectory}/`);
        const [appDirectory] = appPath.split('/');
        return path_1.default.resolve(prefix, projectDirectory, appDirectory);
    }
}
exports.default = ModuleHelper;
//# sourceMappingURL=ModuleHelper.js.map